var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4Yangin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "air-1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 155.6 106.5"
    },
    xmlSpace: "preserve",
    viewBox: "34.6 15.8 86.4 74.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " \t.st0{fill:none;stroke:#000000;stroke-width:3.4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;} ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 46.5,
    y: 81.8,
    className: "st0 svg-elem-1",
    width: 62.5,
    height: 7.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0 svg-elem-2",
    d: "M36.3,48.9c0,0,3.7-22.7,27.8-31.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0 svg-elem-3",
    d: "M45.2,50c0,0,2.1-16.4,20.2-23.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0 svg-elem-4",
    d: "M119.3,48.9c0,0-3.7-22.7-27.8-31.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0 svg-elem-5",
    d: "M110.5,50c0,0-2.1-16.4-20.2-23.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0 svg-elem-6",
    d: "M103.4,81.8H52.6V57.9c0-14,11.4-25.4,25.4-25.4h0c14,0,25.4,11.4,25.4,25.4V81.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0 svg-elem-7",
    d: "M69.9,78.6c5.1,4,12.4,3.9,16.9-0.7c1.5-1.5,2.6-3.4,3.1-6c1.4-8.7-2.4-17.5-2.4-17.5s-3.7,6.5-4.3,5.7  c-0.6-0.8,3.7-11.5-6.2-19.4c0.3,4.4-5.8,14-8.1,17.5c-1.2,1.9-2.2,3.9-2.9,6C64.8,68.3,64.4,74.3,69.9,78.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0 svg-elem-8",
    d: "M83.2,80.5c0,0,3.1-4.8-5.6-14.7c-0.8,3.5-7.2,10.9-6.8,12.5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Yangin);
export default __webpack_public_path__ + "static/media/4.yangin.085c25c663e1c600c41725d09f6be8c1.svg";
export { ForwardRef as ReactComponent };